/**
 * @desc 财务画像-财务舞弊-净利润
 */
import style from './echartsHeight.scss';
import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';
import React from 'react';
import BBDLineBar from '../../../../common/echarts/BBDLineBar';
import { Spin } from 'antd';

export default class NetProfitBar extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            option: {}
        };
    }

    formatResponse = (data) => {
        let years = [];
        data && data.forEach(item => {
            years.push(item.key);
        });
        return {
            option: {
                barData: data,
                barMaxWidth: 40,
                category: years,
                color: ['#ed7d31'],
                legend: false
            }
        };
    };

    render() {
        const { loading, option } = this.state;
        return (
            <div>
                <div className={style.netProfitBar}>
                    {
                        loading ?
                            <Spin /> :
                            <BBDLineBar option={option} />
                    }
                </div>
                <div className="sub-title align-c">净利润</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/NetProfitBar.jsx